/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useMemo, useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';
import { useMutation, ErrorTypes } from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponse,
  getCoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponse';

export type RemoveOrganizationMemberArgs = {
  /**
   * No description provided
   */
  organizationId?: string;

  /**
   * No description provided
   */
  legalEntityId?: string;

  /**
   * No description provided
   */
  memberUuid?: string;

  /**
   * Deprecated: callers must use the ConsensusSessionAPI initiator flow
(GetConsensusSessionStatus -> CompleteConsensusSession) instead of retrying
with a proof token. Inbound non-empty values are ignored by the gate but
counted via consensus.remove_member.proof_token_inbound_use.
   */
  proofToken?: string;
};

export type RemoveOrganizationMemberResult =
  CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponse;

const validateRemoveOrganizationMemberResult = (value: unknown) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: RemoveOrganizationMemberResult data does not match contract.`,
      errors,
    );
  }
};

type HookReturnType = (
  params: RemoveOrganizationMemberArgs,
  options?: RequestInit,
) => Promise<RemoveOrganizationMemberResult | ErrorTypes>;

export const getRemoveOrganizationMemberUrl = (params: RemoveOrganizationMemberArgs) => {
  const searchParams = new URLSearchParams();
  if (params.organizationId !== null && params.organizationId !== undefined) {
    const val = params.organizationId;
    searchParams.append('organization_id', `${val}`);
  }

  if (params.legalEntityId !== null && params.legalEntityId !== undefined) {
    const val = params.legalEntityId;
    searchParams.append('legal_entity_id', `${val}`);
  }

  if (params.memberUuid !== null && params.memberUuid !== undefined) {
    const val = params.memberUuid;
    searchParams.append('member_uuid', `${val}`);
  }

  if (params.proofToken !== null && params.proofToken !== undefined) {
    const val = params.proofToken;
    searchParams.append('proof_token', `${val}`);
  }
  const url = `${getBaseUrl()}/organization/v1/member${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Delete RemoveOrganizationMember
 * @Url /organization/v1/member
 * @Auth Required
 */
export const useRemoveOrganizationMember = (): HookReturnType => {
  const mutation = useMutation<unknown, RemoveOrganizationMemberResult>();

  const callback = useCallback(
    async (params: RemoveOrganizationMemberArgs, options?: RequestInit) => {
      const init = { ...(options || {}), method: 'DELETE' };

      const url = getRemoveOrganizationMemberUrl(params);
      const result = await mutation(url, {}, init);
      if (process.env.NODE_ENV !== 'production') {
        validateRemoveOrganizationMemberResult(result);
      }
      return result;
    },
    [mutation],
  );

  return callback;
};
